import { type ExperienceApp, type ExperienceAppMediaControl } from '@source-digital/sd-app-plugin-experience-app'
import { type Distribution } from 'sd-types/models/distribution'
import { type DirectExperienceAdapter } from './direct-experience-adapter'

class EmbedExperienceMediaControl implements ExperienceAppMediaControl {
  #ee: DirectExperienceAdapter
  constructor (
    ee: DirectExperienceAdapter
  ) {
    this.#ee = ee
  }

  async play (): Promise<void> {
    this.#ee.mediaControl?.play()
  }

  async pause (): Promise<void> {
    this.#ee.mediaControl?.pause()
  }

  async getPaused (): Promise<boolean> {
    return this.#ee.mediaControl?.paused === true
  }

  async getCurrentTime (): Promise<number> {
    return this.#ee.mediaControl?.currentTime ?? 0
  }

  async setCurrentTime (seconds: number): Promise<void> {
    this.#ee.mediaControl?.setCurrentTime(seconds)
  }

  async getDuration (): Promise<number> {
    return this.#ee.mediaControl?.duration ?? 0
  }

  async mute (muted: boolean): Promise<void> {
    this.#ee.mediaControl?.mute(muted)
  }

  async setVolume (value: number): Promise<void> {
    this.#ee.mediaControl?.setVolume(value)
  }

  async getVolume (): Promise<number> {
    return this.#ee.mediaControl?.getVolume() ?? 0
  }
}

export class EmbedExperienceApp implements ExperienceApp {
  #experienceAdapter: DirectExperienceAdapter
  constructor (
    experienceAdapter: DirectExperienceAdapter
  ) {
    this.#experienceAdapter = experienceAdapter
    this.media = new EmbedExperienceMediaControl(experienceAdapter)
  }

  async getDistribution (): Promise<Distribution> {
    return this.#experienceAdapter.data.distribution
  }

  async pushActivations (items: object[]): Promise<void> {
    await this.#experienceAdapter.activationStore.push(items as any)
  }

  async getActivations (): Promise<object[]> {
    return this.#experienceAdapter.activationTimeline.rawItems
  }

  async replaceActivations (items: object[], sources: string[]): Promise<void> {
    await this.#experienceAdapter.activationStore.replaceBySources(items as any, sources)
  }

  async replaceAllActivations (items: object[]): Promise<void> {
    await this.#experienceAdapter.activationStore.replaceBySources(items as any)
  }

  async hideActivations (): Promise<void> {
    this.#experienceAdapter.hideActivations(true)
  }

  async showActivations (): Promise<void> {
    this.#experienceAdapter.hideActivations(false)
  }

  async isCampaignPrefetched (): Promise<boolean> {
    return this.#experienceAdapter.prefetchEnabled
  }

  media: ExperienceAppMediaControl
}
